import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { send } from '../../app/appSlice'
import { AppThunkApi, RootState } from '../../app/store'
import { firstPage, Page } from '../../models/page'
import {
  ProcessingDetail,
  ProcessingPage,
  ProcessingParams,
} from '../../services/processing'
interface processingState {
  processingPage: Page
  processingDetail?: any
}

const initialState: processingState = {
  processingPage: firstPage(),
}

// 分页
export const getProcessingListAsync = createAsyncThunk<
  Page,
  ProcessingParams,
  AppThunkApi
>('ProcessingList/page', async (params, api) => {
  return send(ProcessingPage(params), api)
})

// 详情
export const getProcessingDetailAsync = createAsyncThunk<
  void,
  number,
  AppThunkApi
>('ProcessingDetail/deteil', async (params, api) => {
  return send(ProcessingDetail(params), api)
})

export const processingListSlice = createSlice({
  name: 'ProcessingListStation',
  initialState,
  reducers: {
    setProcessingList(state, action) {
      state.processingPage = action.payload
    },
    setProcessingDetail(state, action) {
      state.processingDetail = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProcessingListAsync.fulfilled, (state, action) => {
      state.processingPage = action.payload
    })
    builder.addCase(
      getProcessingDetailAsync.fulfilled,
      (state, action: any) => {
        state.processingDetail = action.payload
      }
    )
  },
})

export const { setProcessingList, setProcessingDetail } =
  processingListSlice.actions

export const selectProcessingList = (state: RootState): Page =>
  state.processing.processingPage

export const selectProcessingDetail = (state: RootState) =>
  state.processing.processingDetail

export default processingListSlice.reducer
